import type { HackId } from './data';

export type TargetKind = 'sig' | 'bar' | 'cam' | 'fix' | 'vent' | 'veh' | 'npc';
export const HACK_NAMES: Record<HackId, string> = { short_circuit: 'Short Circuit', sensor_jam: 'Sensor Jam', remote_override: 'Remote Override' };

/** Presentation-only reason code sent with a refused hack's warning (`PagerMsg.rc`); the client maps it to a short label. */
export type RefusalCode = 'down' | 'unknown' | 'cooldown' | 'ram' | 'invalid' | 'cant' | 'ineligible' | 'range' | 'busy' | 'blocked';
export const REFUSAL_CODES: readonly RefusalCode[] = ['down', 'unknown', 'cooldown', 'ram', 'invalid', 'cant', 'ineligible', 'range', 'busy', 'blocked'];

/** Which quickhacks apply to a target kind. npcKind is only relevant for 'npc'. */
export function hacksFor(kind: TargetKind, npcKind?: string): HackId[] {
  switch (kind) {
    case 'sig': return ['remote_override'];
    case 'bar': return ['remote_override'];
    case 'cam': return ['sensor_jam', 'short_circuit'];
    case 'fix': return ['short_circuit'];
    case 'vent': return ['remote_override'];
    case 'veh': return ['remote_override'];
    case 'npc': return npcKind === 'drone' ? ['short_circuit', 'sensor_jam'] : npcKind === 'elite' ? ['short_circuit'] : [];
  }
}
/** The single action a driver gets on one press. */
export function defaultHack(kind: TargetKind, npcKind?: string): HackId | null {
  return hacksFor(kind, npcKind)[0] ?? null;
}
export function describeHack(h: HackId, kind: TargetKind, raised?: boolean): string {
  if (h === 'short_circuit') return kind === 'fix' ? 'Overload into an electric hazard' : kind === 'cam' ? 'Burn out camera (jams it)' : 'Electrical damage';
  if (h === 'sensor_jam') return 'Blind its detection';
  if (kind === 'sig') return 'Force all-red: traffic jams here';
  if (kind === 'bar') return raised ? 'Lower barrier' : 'Raise barrier: blocks vehicles';
  if (kind === 'vent') return 'Open steam vent: cuts enemy sight';
  return 'It drives to where you aim (cursor or aim stick)';
}
/** Driver target priority: infrastructure ahead first. */
export const DRIVER_PRIORITY: Record<TargetKind, number> = { bar: 5, sig: 4, fix: 4, vent: 3, cam: 3, npc: 2, veh: 1 };
